import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

/**
 * Reopen a finished subscription
 * Used for WhatsApp, IVR, and SMS survey subscriptions
 */
export const useReopenSub = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [reopenSub, res] = esApi.endpoints.subsReopen.useMutation()

  const resumeSubscription = useCallback(
    async (subId: number) => {
      try {
        const result = await reopenSub({
          orgId: orgId.toString(),
          subId: subId.toString(),
          body: {},
        }).unwrap()

        dispatch(
          createNotification({
            'reopen-subscription': {
              type: 'success',
              message: 'Subscription resumed successfully.',
            },
          }),
        )
        return result
      } catch (err) {
        dispatch(
          createNotification({
            'resume-subscription-failure': {
              type: 'error',
              message: getErrorMessage(err, 'Failed to resume subscription'),
            },
          }),
        )
        return undefined
      }
    },
    [orgId, reopenSub, dispatch],
  )

  return [resumeSubscription, res] as const
}
